/* -------------------------------------------------------------------------------------
Vuex main page. All required vuex modules are imported

Main components
---------------
mutations:
- 

actions:
- 
---------------------------------------------------------------------------------------*/

import Vue from 'vue'
import Vuex from 'vuex'

import * as area from '@/vuex/modules/area.js'
import * as grade from '@/vuex/modules/grade.js'
import * as participant from '@/vuex/modules/participant.js'
import * as notification from '@/vuex/modules/notification.js'
import * as tag from '@/vuex/modules/tag.js'
import * as track from '@/vuex/modules/track.js'
import * as tracksKml from '@/vuex/modules/tracksKml.js'
import * as type from '@/vuex/modules/type.js'
//import * as stat from '@/vuex/modules/stat.js'
import * as user from '@/vuex/modules/user.js'
import * as waypoint from '@/vuex/modules/waypoint.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    area,
    grade,
    notification,
    participant,
    tag,
    track,
    tracksKml,
    type,
    // stat,
    user,
    waypoint
  }
})
